// less
import "./index.less";

// module
import Banner from "./Banner";
import MainBottom from "../../components/MainBottom";

const Module3 = (props) => {
  const { datas } = props;

  const templateFn = (key) => {
    return (datas[key] || { template_common: [] })?.template_common || [];
  };
  return (
    <div className="new_home-module3">
      <div className="module3-top">
        <div className="module3-right">
          {templateFn("right")?.map?.((k, i) => (
            <div className="module3-right-item" key={i}>
              <Banner data={k.value || []} ossSize={600} />
              <div className="template-info flex-center">
                <div className="store-logo">
                  <img src={k.store_logo} alt="" />
                </div>
                <div className="flex1">
                  <div className="store-name">{k.store_name}</div>
                  <div className="template-name owt">{k.template_name}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="new_home_main_bottom">
        <MainBottom data={templateFn("main_bottom_left")} />
        <MainBottom data={templateFn("main_bottom_right")} />
      </div>
    </div>
  );
};
export default Module3;
